/* @flow */
import cx from 'classnames';
import { getPropClassesFromInstance } from 'lib/getPropClasses';
import React from 'react';

import './styles/Heading.scss';

class Heading extends React.Component {
  static propTypes = {
    align: React.PropTypes.oneOf(['left', 'center', 'right']),
    flush: React.PropTypes.bool,
    level: React.PropTypes.oneOf(['1', '2', '3', '4']),
  };

  static propClasses = {
    align: {
      left: 'Heading--left',
      center: 'Heading--center',
      right: 'Heading--right',
    },
    flush: 'Heading--flush',
    level: {
      /* eslint-disable quote-props */
      '1': 'Heading--1',
      '2': 'Heading--2',
      '3': 'Heading--3',
      '4': 'Heading--4',
      /* eslint-enable quote-props */
    },
  };

  static defaultProps = {
    level: '2',
  };

  render() {
    let Component = 'h2';

    if (this.props.level === '1') {
      Component = 'h1';
    } else if (this.props.level === '3') {
      Component = 'h3';
    } else if (this.props.level === '4') {
      Component = 'h4';
    }

    return (
      <Component className={cx('Heading', getPropClassesFromInstance(this), this.props.className)}>
        {this.props.children}
      </Component>
    );
  }
}

export default Heading;



// WEBPACK FOOTER //
// ./src/components/Heading.jsx